import devhints from "../../../../assets/img/programming/devhints.webp";
import devdocs from "../../../../assets/img/programming/devdocs.webp";
import cheatography from "../../../../assets/img/programming/cheatography.webp";
import angular from "../../../../assets/img/programming/angular.webp";
import bitdev from "../../../../assets/img/programming/bitdev.webp";
import angularcli from "../../../../assets/img/programming/angularcli.webp";
import zeal from "../../../../assets/img/programming/zeal.webp";

export const DataDoc = [
  {
    title: "Devhints",
    path: "https://devhints.io/angularjs",
    icon: devhints,
    cName: "icon",
    description: "This is a collection of cheatsheets. Thanks to Rico.",
  },
  {
    title: "Devdocs",
    path: "https://devdocs.io/angular/",
    icon: devdocs,
    cName: "icon",
    description:
      "DevDocs combines multiple API documentations in a fast, organized, and searchable interface. It can be used Offline.",
  },
  {
    title: "Zeal",
    path: "https://zealdocs.org/",
    icon: zeal,
    cName: "icon",
    description:
      "Zeal is an offline documentation browser for software developers. Zeal comes with 200 awesome docsets.",
  },
  {
    title: "Cheatography",
    path: "https://cheatography.com/tag/angularjs/",
    icon: cheatography,
    cName: "icon",
    description:
      "Over 3,500 Free Cheat Sheets, Revision Aids and Quick References. You can create yours.",
  },
  {
    title: "Angular (Official)",
    path: "https://docs.angularjs.org/tutorial",
    icon: angular,
    cName: "icon",
    description: "The Official angular documentation.",
  },
];

export const DataComponents = [
  {
    title: "Bit Dev",
    path: "https://bit.dev/",
    icon: bitdev,
    cName: "icon",
    description:
      "Bit is a scalable and collaborative way to build and reuse components. It's everything you need from local development to cross-project integrations.",
  },
  {
    title: "Angular Material",
    path: "https://material.angular.io/",
    icon: angular,
    cName: "icon",
    description:
      "Angular Material offers a wide variety of UI components based on the Material Design specification.",
  },
  {
    title: "Angular Script",
    path: "https://angularscript.com/",
    icon: angular,
    cName: "icon",
    description:
      "AngularScript.com Aims to offer latest free AngularJS modules  (services, directives, controllers, filters, and reusable components) with live demos for web application developers.",
  },
];

export const DataTools = [
  {
    title: "Angular Cli",
    path: "https://cli.angular.io/",
    icon: angularcli,
    cName: "icon",
    description:
      "The Angular CLI creates, manages, builds and test your Angular projects. It's built on top of the Angular DevKit.",
  },
];
